// @flow
import React, {type Node} from 'react'

type Props = $ReadOnly<{
  className?: string,
  title?: string,
  color?: 'gray' | 'white',
}>

function AgentBadge({className = '', title = 'Agent', color = 'gray'}: Props): Node {
  const fill = color === 'white' ? '#fff' : '#888'
  const accent = color === 'white' ? 'var(--agent-avatar-bg)' : '#fff'

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 28"
      fill="none"
      role="img"
      aria-label={title || 'Agent'}
    >
      {title && <title>{title}</title>}
      <line x1="12" y1="2" x2="12" y2="5" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="12" cy="1.5" r="1.5" fill={fill} />
      <rect x="4" y="5" width="16" height="16" rx="3" fill={fill} />
      <circle cx="9" cy="12.5" r="2" fill={accent} />
      <circle cx="15" cy="12.5" r="2" fill={accent} />
      <path d="M9 17 Q12 19 15 17" stroke={accent} strokeWidth="1.2" strokeLinecap="round" fill="none" />
      <rect x="1" y="10.5" width="2.5" height="5" rx="1" fill={fill} />
      <rect x="20.5" y="10.5" width="2.5" height="5" rx="1" fill={fill} />
    </svg>
  )
}

export default AgentBadge
